export default __webpack_public_path__ + "static/media/Background_00101.9caa5ec0.png";